import styles from './FJProductToVideoScriptEdit.module.less';
import FJLocalStore from '../../../store/FJLocalStore';
import classNames from 'classnames';
import FJAddMediaIcon from '../../../assets/svg/textToVideo/add-media.svg?react';
import FJDeleteMediaIcon from '../../../assets/svg/delete.svg?react';
import FJFileUpload from '../../../common/components/FJFileUpload/FJFileUpload';
import FJButton, { FJButtonType } from '../../../common/components/FJButton/FJButton';
import FJVerticalScroller from '../../../common/components/FJScroller/FJVerticalScroller';
import PropTypes from 'prop-types';
import { UPLOAD_FILE_TYPE_PRODUCE_IMAGE } from '../../../config/dataConfig/FJGenerateData';
import UploadBorderHoverIcon from '../../../assets/svg/upload-border-hover.svg?react';
import UploadBorderIcon from '../../../assets/svg/upload-border.svg?react';
import {
    MAX_PRODUCT_DESCRIPTION_LENGTH,
    MAX_PRODUCT_NAME_LENGTH,
} from '../../../config/dataConfig/FJTextToVideoDataConfig';
import { useState } from 'react';
import FJTextToVideoFooter from '../FJTextToVideoFooter/FJTextToVideoFooter';
import FJAutoHeightTextarea from '../../../common/components/FJAutoHeightTextarea/FJAutoHeightTextarea';

const FJProductToVideoScriptEdit = props => {
    const {
        productName,
        productDescription,
        productMediaList,
        setProductName,
        setProductDescription,
        addMedia,
        deleteMedia,
        onNext,
        previewMedia,
    } = props;
    const [isDraggingFile, setIsDraggingFile] = useState(false);
    const _onPreview = (e, item) => {
        const { id, type, url, duration, width, height } = item;
        const rect = e.currentTarget.getBoundingClientRect();
        const position = { x: rect.right, y: (rect.top + rect.bottom) / 2 };
        const data = {
            position,
            id,
            duration,
            type,
            url,
            viewSize: { width, height },
            target: e.target,
        };
        previewMedia(data);
    };
    const _onDelete = (e, index) => {
        e.stopPropagation();
        deleteMedia(index);
    };
    const _dragCallback = type => {
        if (type === 'leave' || type === 'drop') {
            setIsDraggingFile(false);
        } else if (type === 'over') {
            setIsDraggingFile(true);
        }
    };
    return (
        <div className={styles.container}>
            <FJVerticalScroller className={styles.scroll}>
                <div className={styles.inner}>
                    <div className={styles.title}>{FJLocalStore._('product-name')}</div>
                    <input
                        type='text'
                        className={styles.name_input}
                        value={productName}
                        onChange={e => setProductName(e.target.value)}
                        placeholder={FJLocalStore._('please-enter-the-product-name')}
                        maxLength={MAX_PRODUCT_NAME_LENGTH}
                    />
                    <div className={styles.desc_header_box}>
                        <div className={styles.title}>{FJLocalStore._('product-description')}</div>
                        <div className={styles.count}>
                            {productDescription.length} / {MAX_PRODUCT_DESCRIPTION_LENGTH}
                        </div>
                    </div>
                    <div className={styles.textarea_box}>
                        <FJAutoHeightTextarea
                            className={classNames(styles.textarea, styles.desc)}
                            inputClassName={styles.textarea_input}
                            // minRow={8}
                            // maxRow={18}
                            text={productDescription}
                            onChange={value => setProductDescription(value)}
                            placeholder={FJLocalStore._('please-fill-in-the-product-description-selling-points-etc')}
                            maxLength={MAX_PRODUCT_DESCRIPTION_LENGTH}
                            padding={'0 8px 0 0'}
                        />
                    </div>
                    <div className={styles.title}>{FJLocalStore._('product-media')}</div>
                    <div className={styles.media_container}>
                        <FJFileUpload
                            multiple={true}
                            className={classNames(styles.upload_box, isDraggingFile ? styles.dragging : '')}
                            onUpload={addMedia}
                            accept={UPLOAD_FILE_TYPE_PRODUCE_IMAGE}
                            dragCallback={_dragCallback}
                        >
                            <FJAddMediaIcon />
                            <span className={styles.upload_text}>{FJLocalStore._('add-media')}</span>
                            <UploadBorderHoverIcon className={styles.upload_border_hover} />
                            <UploadBorderIcon className={styles.upload_border} />
                        </FJFileUpload>
                        {productMediaList.map((item, index) => (
                            <div className={styles.media_item} key={index} onClick={e => _onPreview(e, item)}>
                                <img className={styles.media_item_img} src={item.url} alt='' />
                                <div className={styles.delete_box}>
                                    <FJDeleteMediaIcon
                                        className={styles.delete_icon}
                                        onClick={e => _onDelete(e, index)}
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </FJVerticalScroller>
            <FJTextToVideoFooter>
                <FJButton
                    className={styles.btn}
                    onClick={onNext}
                    type={FJButtonType.GRADIENT}
                    text={FJLocalStore._('next')}
                />
            </FJTextToVideoFooter>
        </div>
    );
};

FJProductToVideoScriptEdit.propTypes = {
    productName: PropTypes.string,
    productDescription: PropTypes.string,
    productMediaList: PropTypes.array,
    setProductName: PropTypes.func,
    setProductDescription: PropTypes.func,
    addMedia: PropTypes.func,
    deleteMedia: PropTypes.func,
    onNext: PropTypes.func,
    previewMedia: PropTypes.func,
};

export default FJProductToVideoScriptEdit;
